<template>
  <div class="form-multiple">
    <h1 class="title">{{questionTitle}}</h1>

    <div class="multiple-options answer"
      v-for="answer in answerOptions"
      :key="answer.description"
      @click="selectAnswer(answer)"
      :class="{ 'is-active': answer.value === selectedAnswer.value }">

      <p>{{answer.translation_entries[0].body}}</p>
    </div>
  </div>
</template>

<script>
import {required} from 'vuelidate/lib/validators'

import {getQuestionnaireAnswer} from '@/api/questionnaire'

export default {
  props: {
    question: Object,
    questionTitle: String
  },

  data() {
    return {
      selectedAnswer: false,
      answered: false
    }
  },

  validations: {selectedAnswer: {required}},

  computed: {
    answerOptions() {
      return this.question.answer.options
    },

    patientId() {
      return this.$route.params.id
    },
    questionnaireId() {
      return this.$route.params.questionnaireId
    }
  },

  mounted() {
    this.checkQuestionStatus()
  },

  methods: {
    selectAnswer(answer) {
      this.selectedAnswer = answer
      this.$emit('update', {name: this.selectedAnswer.value, id: this.question.id, value: answer.value})
      // this.selectedAnswer = answer.value
      // this.$emit('update', {name: this.selectedAnswer, id: this.question.id, value: answer.value})
    },

    checkQuestionStatus() {
      // Check if the question has been answered
      const questionId = this.question.id

      getQuestionnaireAnswer(questionId, this.patientId, this.questionnaireId)
        .then((response) => {
          const hasAnswer = response.data[0].answer.id

          if(hasAnswer) {
            this.$emit('answered', true)

            // Set answered answer
            const value = response.data[0].value
            const answer = response.data[0].answer.options.find((option) => {
              return option.value === value
            })

            this.selectedAnswer = answer

            this.$emit('currentQuestionAnswer', response.data[0])
          } else {
            this.$emit('answered', false)
          }
        })
        .catch(() => {
        })
    }
  }
}
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'

  .form-multiple
    display: flex
    flex-flow: row wrap
    text-align: left
    flex-direction: column
    padding-top: 30px

    .title
      font-size: 25px

    .multiple-options
      display: flex
      align-items: center

      p
        padding-left: 1rem
        font-weight: 700

        &:first-letter
          text-transform: capitalize 

    .answer
      position: relative
      cursor: pointer

      &:before, &:after
        content: ''
        background: none
        border-radius: 50%

      &:before
        content: ''
        width: 20px
        height: 20px
        background: none
        border: 2px solid rgba(0, 0, 0, 0.75)
        border-radius: 50%

      &:after
        content: ''
        width: 10px
        height: 10px
        position: absolute
        top: 24px
        left: 5px
        transform: scale(0)
        transition: transform .2s ease-in-out

      &.is-active
        &:after
          background: $color-primary
          transform: scale(1)
</style>



// WEBPACK FOOTER //
// src/components/pages/Questionnaire/Elements/Multiple.vue